import React from 'react';
import {
  GDSStyleObject,
  Card,
  ParagraphText,
  HeadingText,
  Button,
  useMediaQuery,
  queryHelpers,
  Box,
} from '@leagueplatform/genesis-core';
import { EVENT_NAME, trackAnalyticsEvent } from '@leagueplatform/analytics';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import GlossaryContent from '../../assets/json/glossary-content.json';

export function ChatSectionComponent() {
  const navigate = useNavigate();
  const isBetweenTabletAndDesktop = useMediaQuery(
    queryHelpers.between(['tablet', 'desktop']),
  );

  const isBetweenDownSizeMobile = useMediaQuery(
    queryHelpers.between([344, 399]),
  );

  const trackAnalytics = (buttonName: string, product: string) => {
    trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
      product_area: product,
      screen_name: 'Health Insurance Glossary Page',
      detail: `${buttonName}`,
      path: window.location.pathname,
      event_author: 'engen',
    });
  };

  const handleChatClick = () => {
    navigate('/support/live-chat');
  };

  return (
    <Card.Flat>
      <Card.Section
        css={
          {
            boxSizing: 'border-box',
            border: '1px solid #CCCCCC',
            borderRadius: '$large',
            margin: '0px auto',
            width: '100%',
            maxWidth: '288px',
            height: '216px',
            padding: '$one',
            display: 'ruby',
            '@mobile': {
              maxWidth: isBetweenDownSizeMobile ? '345px' : '385px',
              height: '216px',
              marginLeft: '5px',
            },
          } as GDSStyleObject
        }
      >
        <Box
          css={
            {
              maxWidth: '288px',
              height: '216px',
              display: 'ruby',
              '@mobile': {
                maxWidth: '295px',
                height: '216px',
                marginLeft: '5px',
              },
            } as GDSStyleObject
          }
        >
          <HeadingText
            level="3"
            size={{
              '@initial': 'xxl',
              '@laptop': 'xxl',
              '@desktop': 'xxl',
              '@mobile': 'md',
              '@mobileLandscape': 'xxl',
              '@tablet': 'xxl',
            }}
            css={{
              position: 'relative',
              fontSize: '$headingThree',
              textAlign: 'left',
              letterSpacing: '0.25px',
              width: '256px',
              height: '56px',
              lineHeight: '24px',
              '@mobile': {
                paddingLeft: '$none',
                top: '10px',
                textAlign: 'left',
              },
              '@tablet': { paddingLeft: '$none', top: '10px' },
              '@mobileLandscape': {
                paddingLeft: '$none',
                textAlign: 'left',
                width: '327px',
                top: '10px',
              },
              '@laptop': {
                paddingLeft: '$none',
                top: isBetweenTabletAndDesktop ? '10px' : '35px',
              },
              '@desktop': { padding: '$none' },
            }}
          >
            {GlossaryContent.GLOSSARY.CHATSECTIONTITLE}
          </HeadingText>
          <ParagraphText
            css={{
              fontSize: '$subtitleOne',
              paddingTop: '20px',
              paddingBottom: '15px',
              textAlign: 'left',
              lineHeight: '24px',
              top: isBetweenTabletAndDesktop ? '10px' : '0px',
            }}
          >
            {GlossaryContent.GLOSSARY.CHATSUBSECTIONTITLE}
          </ParagraphText>
          <Button
            priority="primary"
            size="large"
            textAlign="start"
            type="button"
            width="fillContainer"
            css={{
              textAlign: 'center',
            }}
            as="a"
            onClick={() => {
              trackAnalytics(
                GlossaryContent.GLOSSARY.CHATSUBSECTIONBUTTON,
                'glossary',
              );
              handleChatClick();
            }}
            target="_self"
            data-testid="chatNow"
          >
            {GlossaryContent.GLOSSARY.CHATSUBSECTIONBUTTON}
          </Button>
        </Box>
      </Card.Section>
    </Card.Flat>
  );
}
